/**************************************************
 * Nombre:       Formulario_Cange
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Button, Grid, Typography} from "@mui/material";
import IngresoTexto from "../../Modulo_formularios/Componentes/IngresoTexto";
import {AccountCircleOutlined, EmojiFlagsOutlined, FlagOutlined, Google} from "@mui/icons-material";
import {ESTADOSMOVIMIENTO} from "../../Constantes";
import IngresoSelect from "../../Modulo_formularios/Componentes/IngresoSelect";
import {useEffect, useState} from "react";
import {useFormulario} from "../../Modulo_formularios/Hooks/useFormulario";
import Formulario_Cange_Datos from "./Formulario_Cange_Datos";

const Formulario_Cange = ({...props}) => {
    const [datos, setDatos] = useState({})
    const {props: propsDatos, obtenerEntidad, setEntidad} = useFormulario({valoresDefecto: {}})
    const [cargando,setCargando] = useState(false)

    const guardarDatos = async () => {

        let entidad = await obtenerEntidad()
        setCargando(true)
        props.props.setValue('datos', entidad)
        setTimeout(() =>{
            setCargando(false)
        },1500)


    }

    useEffect(() => {
        let datos = props.props.getValues('datos')
        if (datos) {
            setEntidad(datos)
            setDatos(datos)
        }
    }, []);
    return (
        <form noValidate style={{width: '100%'}}>
            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                spacing={2}
            >

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                    <Typography>Datos de Usuario</Typography>
                </Grid>


                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <IngresoTexto Icono={AccountCircleOutlined} nombre={'Nombre de Usuario'} dato={'nombre'} {...props}
                                  requerido={'El Nombre es requerido'} editable={false}
                    />
                </Grid>

                <Grid container size={12}>
                    <IngresoTexto Icono={Google} nombre={'Correo'} dato={'correo'} {...props}
                                  editable={false}
                    />
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                    <Typography>Datos del Retiro</Typography>
                </Grid>


                <Grid container size={6}>
                    <IngresoSelect Icono={EmojiFlagsOutlined} nombre={'Estado'} dato={'estado'} {...props}
                                   opciones={ESTADOSMOVIMIENTO}
                    />
                </Grid>

                <Grid container size={6}>
                    <IngresoTexto Icono={FlagOutlined} nombre={'Puntos a Cangear'} dato={'valor'} {...props}
                                  editable={false}
                    />
                </Grid>

                <Grid container size={12}>
                    <IngresoTexto Icono={FlagOutlined} nombre={'Premio reclamado'} dato={'metodo'} {...props}
                                  editable={false}
                    />
                </Grid>


                <Grid container size={12}>
                    <IngresoTexto lineas={3} nombre={'Notas para Usuario'} dato={'detalle'} {...props}

                    />
                </Grid>

                {datos &&

                    <>
                        <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                            <Formulario_Cange_Datos props={propsDatos}/>
                        </Grid>

                        <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-end'}}>
                            <Button
                                loading={cargando}
                                onClick={() => guardarDatos()}
                                variant={'outlined'}>Guardar datos Envio</Button>
                        </Grid>

                    </>

                }


            </Grid>

        </form>

    )

}
export default Formulario_Cange